<script>

    import {determineHost} from "./config";
    import {formatDate, millisecondsToStr, fromEpoch} from "./dateutil";
    let history = [];
    let host = determineHost();
    fetch(`${host}/timer/history5`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(json => history = json)

</script>

<h1>History last 5 days</h1>


{#each history as item}

    <div style="padding: 10px 0; border-top: 1px solid black">

        {#if item.firstEntryDate}
           First log: {formatDate(fromEpoch(item.firstEntryDate))}
        {:else}
            No entries
        {/if}
        <br>
        Count: {item.totalEntries}
        <br>
        Created on:
        {#if item.binDay}
            {formatDate(fromEpoch(item.binDay))}
        {/if}
        <br>

        {#if item.binEndDate}
            End log: {formatDate(fromEpoch(item.binEndDate))}
        {/if}
    </div>
{/each}

